import { Text, View } from '@react-pdf/renderer';
import { IPDFSmallLetterProps } from './IPDFSmallLetter';
import { styles } from './PDFSmallLetterStyle';

const PDFSmallLetter = (props: IPDFSmallLetterProps) => {
    return (
        <View style={styles.center}>
            <Text style={styles.letterWrapper}>
                {props.normal}
                <View style={styles.normalLetter}>
                    <Text style={[styles.smallLetter,{ fontFamily: 'Noto Sans' }]}>{props.small}</Text>
                </View>
            </Text>
        </View>
    );
};

export default PDFSmallLetter;
